import dynamic from 'next/dynamic';

export interface LoaderProps {
  container?: HTMLDivElement | null;
  showOnScommessaLoading?: boolean;
}

export interface ScommesseFallbackProps extends LoaderProps {
  hasFilter: boolean;
  hasRedirect: boolean;
  resetFilter?: () => void;
}

export { Loader } from './ScommesseFallback';

export const EmptyLive = dynamic<ScommesseFallbackProps>(
  () => import('components/scommessaFallback/ScommesseFallback').then((mod) => mod.EmptyLive),
  { ssr: false }
);
export const EmptySport = dynamic<ScommesseFallbackProps>(
  () => import('components/scommessaFallback/ScommesseFallback').then((mod) => mod.EmptySport),
  { ssr: false }
);
